export default __webpack_public_path__ + "static/media/jaw.6292f18c.JPG";